import RequestUtils from "../utils/RequestUtils";
import ShopRes from "types/res/shop/ShopRes";

export default class ShopApi {
  static async fetchShops(companyId: number) {
    return await RequestUtils.getArray(ShopRes, `/shop/findAll/${companyId}`);
  }
}
